/** Browser store retained for shared-worker use and desktop cutover. */
export const SHARED_REPO_DB_NAME = 'mod-shared-repo-v1'

/**
 * The direct desktop tab's own store (RFC 0359 3e). Separate from the shared
 * worker's database so the two repo owners never share a store, and never
 * opened by a browser tab.
 */
export const DESKTOP_TAB_DB_NAME = 'mod-desktop-tab-v1'
